import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Meta} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {SocialsDTO} from '@rsp/models/dto/tenants-details.dto';
import {RegionalAuthService} from '@rsp/shared/services/regional-auth.service';
import {TenantConfigService} from '@rsp/shared/services/tenant-config.service';
import {environment} from '@env/environment';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';
import {UserService} from '@rsp/shared/services/user.service';


@Component({
  selector: 'rsp-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {
  sociallinks: SocialsDTO[] = [];
  today = new Date();

  thccolor1: string;
  thccolor2: string;
  thccolor3: string;

  public title = 'test';

  public isMock: boolean;

  constructor(
    private router: Router,
    private authService: RegionalAuthService,
    private userService: UserService,
    private meta: Meta,
    private tenants: TenantConfigService,
    private tracker: UserTrackingService,
  ) {
    this.initUserTracker();

    this.isMock = environment.mock;
    this.meta.addTag({
      name: 'description',
      content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
    }, true);

    this.tenants.getSocials().then((socials) => {
      this.sociallinks = socials;
    });

  }

  ngOnInit() {
    if (this.tenants.getInfo()) {
      const dto = this.tenants.getInfo();

      const rootStyle: CSSStyleDeclaration = document.querySelector<HTMLElement>(':root').style;

      rootStyle.setProperty('--branding-color0', dto.brandingColor0);
      rootStyle.setProperty('--branding-color1', dto.brandingColor1);
      rootStyle.setProperty('--branding-color2', dto.brandingColor2);

      rootStyle.setProperty('--text-color0', dto.textColor0);
      rootStyle.setProperty('--text-color1', dto.textColor1);
      rootStyle.setProperty('--text-color2', dto.textColor2);

      rootStyle.setProperty('--graph-color0', dto.graphColor0);
      rootStyle.setProperty('--graph-color1', dto.graphColor1);
      rootStyle.setProperty('--graph-color2', dto.graphColor2);
      rootStyle.setProperty('--graph-color3', dto.graphColor3);
      rootStyle.setProperty('--graph-color4', dto.graphColor4);
    }
  }

  private initUserTracker() {
    this.tracker.init();

    if (this.userService.getFullname()) {
      this.tracker.setUserid(this.userService.getFullname());
    }
  }

  public trackNotImplemented(link: string) {
    this.tracker.trackEvent('Not Implemented', 'Navigate', link);
  }

}
